import React, { useState } from 'react';
import getRedirectQueryString from '../account/getRedirectQueryString';
import useAppSelector from '../app/redux/useAppSelector';
import Button from '../components/Button';
import IconButton from '../components/IconButton';
import SVGIcon from '../components/SVGIcon';
import TeamIcon from '../organization/TeamIcon';
import { useIsSize } from '../utils/responsive/isSize';
import Sizes from '../utils/responsive/Sizes';
import ExternalSearchInput from './ExternalSearchInput';
import styles from './ExternalTopbar.module.scss';
import searchIcon from '../icons/search.svg';

interface BaseExternalTopbarProps {
  children: React.ReactNode;
}
const BaseExternalTopbar = ({ children }: BaseExternalTopbarProps) => {
  return (
    <div id="topbar" className={styles.externalTopbar}>
      {children}
    </div>
  );
};

const LoginButton = () => {
  const redirectPath = useAppSelector(
    (state) => state.ui.externalTopbarLoginRedirectPath,
  );

  return (
    <Button
      variant="secondary"
      to={`/login${getRedirectQueryString(redirectPath)}`}
    >
      Log in
    </Button>
  );
};

const TeamIconLink = () => {
  return (
    <a href="/">
      <TeamIcon />
    </a>
  );
};

const ExternalTopbarWithSearch = () => {
  const [isShowingSearchOnMobile, setIsShowingSearchOnMobile] = useState(false);
  const isSmall = useIsSize(Sizes.SM);

  return (
    <BaseExternalTopbar>
      <div className={styles.left}>
        <TeamIconLink />
        {(!isSmall || isShowingSearchOnMobile) && (
          <ExternalSearchInput autoFocus={isSmall} />
        )}
        {!isShowingSearchOnMobile && isSmall && (
          <IconButton onClick={() => setIsShowingSearchOnMobile(true)}>
            <SVGIcon size="large">{searchIcon}</SVGIcon>
          </IconButton>
        )}

        {isSmall && isShowingSearchOnMobile && (
          <Button onClick={() => setIsShowingSearchOnMobile(false)}>
            Cancel
          </Button>
        )}
      </div>

      {(!isShowingSearchOnMobile || !isSmall) && <LoginButton />}
    </BaseExternalTopbar>
  );
};

const ExternalTopbar = () => {
  return (
    <BaseExternalTopbar>
      <TeamIconLink />
      <LoginButton />
    </BaseExternalTopbar>
  );
};

ExternalTopbar.WithSearch = ExternalTopbarWithSearch;

export default ExternalTopbar;
